(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-press"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', () => {
		const section = document.querySelector('[data-press-section]');
		if (!section) return;

		const sidebarLinks = section.querySelectorAll('.press-sidebar a');
		const contentBlocks = section.querySelectorAll('.press-main .press__content');

		// Filter links that are hash-based for tabs
		const tabLinks = Array.from(sidebarLinks).filter(link => {
			const href = link.getAttribute('href');
			return href && href.includes('#');
		});

		const activateTab = (index) => {
			// Remove active class from all sidebar items (targeting parent li as per CSS)
			sidebarLinks.forEach(link => {
				link.closest('li')?.classList.remove('is-active');
				link.classList.remove('is-active');
			});

			// Hide all content blocks
			contentBlocks.forEach(block => {
				block.style.display = 'none';
			});

			// Activate current
			const activeLink = tabLinks[index];
			if (activeLink) {
				activeLink.closest('li')?.classList.add('is-active');
				activeLink.classList.add('is-active');
			}

			const activeContent = contentBlocks[index];
			if (activeContent) {
				activeContent.style.display = 'block';
			}
		};

		tabLinks.forEach((link, index) => {
			link.addEventListener('click', (e) => {
				const href = link.getAttribute('href');
				e.preventDefault();
				activateTab(index);
				if (href !== '#') {
					history.replaceState(null, null, href);
				}
			});
		});

		// Initial state
		if (tabLinks.length > 0) {
			const currentHash = window.location.hash;
			let startIndex = 0;

			if (currentHash) {
				const hashIndex = tabLinks.findIndex(link => link.getAttribute('href') === currentHash);
				if (hashIndex !== -1) startIndex = hashIndex;
			}

			activateTab(startIndex);
		}
	});

  } catch(e) { console.error(e); }
})();
})();
